import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import SongRequestService from "./song_request_service";
import {SongRequest} from "../../utils/types";
import {SongRequestState} from "./types";

export const createSongRequest = createAsyncThunk(
    "songRequests/createSongRequest",
    async (payload: Partial<SongRequest>, {rejectWithValue}) => {
        try {
            // Call the register endpoint from the API
            const data = await SongRequestService.createSongRequest(payload);

            // Return the response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error.response.data.message || error.message);
        }
    }
);

export const getSongRequests = createAsyncThunk(
    "songRequests/getSongRequests",
    async (_, {rejectWithValue}) => {
       try {
           // Call the login endpoint from the API
          return SongRequestService.getSongRequests();

       } catch (error: any) {
              // If server error, throw error
              return rejectWithValue(error.response.data.message || error.message);
       }
    }
);

export const voteSongRequest = createAsyncThunk(
    "songRequests/voteSongRequest",
    async (id: number, {rejectWithValue}) => {
        try {
            // Call the login endpoint from the API
            return SongRequestService.voteSongRequest(id);

        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error.response.data.message || error.message);
        }
    }
);

const intialState: SongRequestState = {
    song_requests: [],
    search_results: [],
    song_request: null,
    loading: false,
    error: null
}

const songRequestSlice = createSlice({
    name: "songRequests",
    initialState: intialState,
    reducers: {
        setSongRequests: (state, action) => {
            state.song_requests = action.payload;
        },
        setSearchResults: (state, action) => {
            state.search_results = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(createSongRequest.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(createSongRequest.fulfilled, (state, action) => {
            state.loading = false;
            state.song_request = action.payload;
        });
        builder.addCase(createSongRequest.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });
        builder.addCase(getSongRequests.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getSongRequests.fulfilled, (state, action) => {
            state.loading = false;
            state.song_requests = action.payload;
        });
        builder.addCase(getSongRequests.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message as string;
        });
        builder.addCase(voteSongRequest.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(voteSongRequest.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(voteSongRequest.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message as string;
        });
    }
});

export const {setSongRequests, setSearchResults} = songRequestSlice.actions;

export default songRequestSlice.reducer;
